const initialPolicySubReason = {
  policySubReasonPermissions: {},
  policySubReasonLists: [],
  policySubReasonStatus: [],
  changedPolicySubReasonStatus: [],
  loadingPolicySubReason: false,
  errorsPolicySubReason: {},
};

const policySubReasonReducer = (policySubReason = initialPolicySubReason, action) => {
  switch (action.type) {
    case "GET_POLICYSUBREASONLIST_PENDING":
    case "ADD_POLICY_SUB_REASON_PENDING":
    case "UPDATE_POLICY_SUB_REASON_PENDING":
    case "UPDATE_POLICY_SUB_REASON_STATUS_PENDING":
    case "DELETE_POLICY_SUB_REASON_PENDING":
    case "GET_POLICYSUBREASONLISTBYID_PENDING":
      return { ...policySubReason, loadingPolicySubReason: true };

    case "GET_POLICYSUBREASONLIST_FULFILLED":
      return {
        ...policySubReason,
        loadingPolicySubReason: false,
        policySubReasonLists: action.payload,
        policySubReasonCount: action.count,
        policySubReasonPermissions: action.permissions,
      };

    case "ADD_POLICY_SUB_REASON_FULFILLED":
    case "UPDATE_POLICY_SUB_REASON_FULFILLED":
    case "UPDATE_POLICY_SUB_REASON_STATUS_FULFILLED":
    case "DELETE_POLICY_SUB_REASON_FULFILLED":
      return {
        ...policySubReason,
        loadingPolicySubReason: false,
        changedPolicySubReasonStatus: action.payload,
      };

    case "GET_POLICYSUBREASONLISTBYID_FULFILLED":
      return {
        ...policySubReason,
        loadingPolicySubReason: false,
        policySubReasonLists: action.payload,
      };

    case "RESET_DELETE_POLICY_SUB_REASON_STATUS":
      return {
        ...policySubReason,
        loadingPolicySubReason: false,
        policySubReasonStatus: {},
        changedPolicySubReasonStatus: [],
        errorsPolicySubReason: {},
      };

    case "GET_POLICYSUBREASONLIST_REJECTED":
    case "ADD_POLICY_SUB_REASON_REJECTED":
    case "UPDATE_POLICY_SUB_REASON_REJECTED":
    case "UPDATE_POLICY_SUB_REASON_STATUS_REJECTED":
    case "DELETE_POLICY_SUB_REASON_REJECTED":
    case "GET_POLICYSUBREASONLISTBYID_REJECTED":
      return {
        ...policySubReason,
        loadingPolicySubReason: false,
        errorsPolicySubReason: action.payload,
      };

    default:
      return policySubReason;
  }
};

export default policySubReasonReducer;
